import { applyCreatableDraftPlacement, clearCreatableDraftPlacement } from "./applyCreatableDraftPlacement.js";
import { injectStyle, resizeOpposite } from "./injectStyle.js";
import { uuid } from "./tree.js";
function getRecursivelyCheckedNodes(tree, withDepth = false) {
    if (withDepth) {
        let depth = 0;
        const result = {};
        const fnChild = (obj)=>{
            if (!obj.$visible) {
                return;
            }
            const { childNodes = [], checked } = obj;
            if (checked) {
                if (!result[depth]) {
                    result[depth] = [];
                }
                result[depth].push(obj);
            }
            if (childNodes.length) {
                depth++;
                childNodes.forEach(fnChild);
                depth--;
            }
        };
        tree.forEach(fnChild);
        return result;
    }
    const result = [];
    const fnChild = (obj)=>{
        if (!obj.$visible) {
            return;
        }
        const { childNodes = [], checked } = obj;
        checked && result.push(obj);
        if (childNodes.length) {
            childNodes.forEach(fnChild);
        }
    };
    tree.forEach(fnChild);
    return result;
}
function _findTreeItemById(id, tree = [], callback, parentId = 0) {
    for(let i = 0; i < tree.length; i++){
        if (tree[i].id === id) {
            callback(tree[i], parentId);
            break;
        } else if (tree[i].childNodes) {
            _findTreeItemById(id, tree[i].childNodes, callback, tree[i].id);
        }
    }
}
function getTreeParentById(id, tree, parentId = 0) {
    let found;
    _findTreeItemById(id, tree, (_node, parent)=>found = parent, parentId);
    return found;
}
export { applyCreatableDraftPlacement, clearCreatableDraftPlacement, getRecursivelyCheckedNodes, getTreeParentById, injectStyle, resizeOpposite, uuid };
